<template>
    <div class="calculator bold">
        <div v-if="editable" class="d-flex align-items-center justify-content-center">
            <div class="more" @click="doTheMath('subtract')">
                <span class="ico-minus"></span>
            </div>
            
            <input type="text" class="mx-2 my-0" :value="object[field]" @input="directInput">

            <div class="less" @click="doTheMath('add')">
                <span class="ico-add"></span>
            </div>
        </div>
        <div v-else class="mx-2 my-0 fs-large">{{ input }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            object: Object,
            field: String,
            max: {
                type: Number,
                required: false
            },
            editable: {
                type: Boolean,
                default: true,
            }
        },
        data: function() {
            return {
                input: 0,
            }
        },
        created: function() {
            this.input = this.object[this.field];  
        },
        methods: {
            directInput: function(e) {
                const value = e.target.value;

                if (value >= 0 && value <= this.max) {
                    this.$emit('mathDone', {
                        object: this.object,
                        field: this.field,
                        value: value,
                    });
                }
                else {
                    e.target.value = this.object[this.field];
                }
            },
            doTheMath: function(operation) {
                const count = parseInt(this.object[this.field]);

                if (operation == 'add' && (!this.max || (this.max && count < this.max))) {
                    this.input = count + 1;
                }
                else if (operation == 'subtract' && count >= 1) {
                    this.input = count - 1;
                }

                this.$emit('mathDone', {
                    object: this.object,
                    field: this.field,
                    value: this.input,
                });
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .calculator {
        .more, .less {
            border-radius: 3px;
            border: 1px solid $medium;
            background: $faded;
            padding: 0.4rem 1rem 0.5rem;
            color: $dark;
            cursor: pointer;
        }

        input[type=text] {
            width: 48px;
            text-align: center;
            border-color: $medium;
        }
    }
</style>



// WEBPACK FOOTER //
// Calculator.vue?245500f0